import { apiGet } from './client';

export type EmailSortField = 'email' | 'createdAt';
export type EmailSortOrder = 'asc' | 'desc';

export interface EmailListItem {
  email: string | null;
  createdAt: string;
}

export interface EmailListResult {
  items: EmailListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface EmailListParams {
  page?: number;
  limit?: number;
  sortBy?: EmailSortField;
  sortOrder?: EmailSortOrder;
}

/**
 * GET /admin/feedback/emails — paginated newsletter-signup email list (the
 * feedback table's "Newsletter Registration Request" rows).
 */
export function listEmails(params: EmailListParams = {}): Promise<EmailListResult> {
  return apiGet<EmailListResult>('/admin/feedback/emails', params);
}

/**
 * Fetches every matching row (bypassing pagination) so the caller can build
 * a full CSV export client-side, using the current sort.
 */
export async function fetchAllEmails(
  sortBy: EmailSortField,
  sortOrder: EmailSortOrder,
): Promise<EmailListItem[]> {
  const first = await listEmails({ page: 1, limit: 1, sortBy, sortOrder });
  if (first.total === 0) return [];
  const all = await listEmails({ page: 1, limit: first.total, sortBy, sortOrder });
  return all.items;
}
